import React from 'react';
import './OnlineMockExamCourses.scss';
import MainLayout from '../../components/TheMainLayout/MainLayout';
import { Switch, Route } from 'react-router-dom';
import { routesURLs } from '../../Routes';
import OnlineMockExamCoursesDetail from './OnlineMockExamCoursesDetail';
import OnlineMockExamCoursesList from './OnlineMockExamCoursesList';

const OnlineMockExamCourses = () => {
    return (
        <MainLayout>
            <Switch>
                <Route
                    path={`${routesURLs.onlineMockExamCourses}`}
                    exact={true}
                    render={(props) => <OnlineMockExamCoursesList {...props} />}
                />
                <Route
                    path={`${routesURLs.onlineMockExamCourses}/:id`}
                    exact={true}
                    render={(props) => <OnlineMockExamCoursesDetail {...props} />}
                />
            </Switch>
        </MainLayout>
    );
};

export default OnlineMockExamCourses;

